import type { FragmentOf } from "@opensea/graphql"
import { readFragment } from "@opensea/graphql"
import { FlexColumn, Table } from "@opensea/ui-kit"
import type { CancelOrderFlowView } from "../../types"
import { CancelOrderTableRow } from "../CancelOrderTableRow/CancelOrderTableRow"
import { CancelOrderTableFragment } from "./CancelOrderTable.fragment"
import { CancelOrderTableHeader } from "./CancelOrderTableHeader"

type Props = {
  orders: FragmentOf<typeof CancelOrderTableFragment>[]
  filteredOrderIds?: string[]
  view: CancelOrderFlowView
}

export const CancelOrderTable = ({
  orders: orderKeys,
  filteredOrderIds,
  view,
}: Props) => {
  const orders = orderKeys.map(orderKey =>
    readFragment(CancelOrderTableFragment, orderKey),
  )

  const filteredOrders = filteredOrderIds
    ? orders.filter(order => filteredOrderIds.includes(order.id))
    : orders

  return (
    <FlexColumn className="w-full">
      <Table
        context={{ view }}
        header={<CancelOrderTableHeader orders={filteredOrders} />}
        itemKey={item => item?.id}
        items={filteredOrders}
        renderRow={CancelOrderTableRow}
        size="xl"
      />
    </FlexColumn>
  )
}
